import { WEBHOOKS_PATHS } from '../constants/const'

/**
 * Calls the webhook to process a pluviometric chart file.
 * The webhook reads the file from storage and writes parsed data to Firestore (app/v1/pluviometricCharts).
 * @param {string} deviceId - Device ID for the URL path
 * @param {string} storagePath - Path where the chart file was uploaded in storage
 * @returns {Promise<{ ok: boolean, chartId?: string, data?: object }>} Response with ok and optional chartId/data from backend
 */
export async function callProcessPluviometricChart (deviceId, storagePath) {
  const baseUrl = (process.env.WEBHOOKS_URL || '').replace(/^['"]|['"]$/g, '')
  const token = (process.env.WEBHOOKS_BASIC_TOKEN || '').replace(/^['"]|['"]$/g, '')
  const path = `${WEBHOOKS_PATHS.PROCESS_PLUVIOMETRIC_CHART}/${encodeURIComponent(deviceId)}`
  const url = `${baseUrl}${path}`

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: token
    },
    body: JSON.stringify({ storagePath })
  })

  const data = await response.json().catch(() => ({}))
  return {
    ok: response.ok,
    status: response.status,
    chartId: data.chartId || data.id,
    data
  }
}



// WEBPACK FOOTER //
// ./src/lib/pluviometricChartWebhook.js